import React from "react";

const PrivacyOnePDF = () => {
    return <div className="app">
        <div id={"form"} className={"layer full-screen"} style={{overflowY: "scroll", display: "block"}}>
            <div className="container">
                <div className="row">
                    <div className="col-8 col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 ms-auto me-auto">
                        <div id={"search-form"} className="search-form row g-3">
                            <div className="col-12">
                                <h1>
                                    Privacy Policy
                                </h1>
                                <p>
                                    Effective Date: 21.02.26
                                    <br/><br/>
                                    Welcome to OnePDF ("we," "our," or "us"). We do not collect, process, or store
                                    personal data when you use this website. We also do not use external services for
                                    analytics, tracking, maps, or data processing. This Privacy Policy explains this
                                    approach in a transparent way.
                                    <br/><br/>
                                    1. Data Controller
                                    <br/><br/>
                                    Even though no personal data is processed, the responsible provider of this
                                    website is:
                                    <br/><br/>
                                    <strong>OnePDF</strong><br/>
                                    Michael Böhm<br/>
                                    Königsbrücker Str. 91<br/>
                                    01099 Dresden<br/>
                                    Germany<br/>
                                    +4915788414388<br/>
                                    <a href={`mailto:info@kooksurfffinder.com`}>info@kooksurfffinder.com</a>
                                    <br/><br/>
                                    2. Personal Data We Collect
                                    <br/><br/>
                                    We do not collect any personal data. In particular, we do not collect location
                                    data, contact data, account data, tracking data, or cookie-based identifiers.
                                    <br/><br/>
                                    3. How We Use Your Data
                                    <br/><br/>
                                    Since we do not process personal data, there is no use of personal data for any
                                    purpose.
                                    <br/><br/>
                                    4. Third-Party Services
                                    <br/><br/>
                                    We do not use third-party services that process personal data. In particular, we do
                                    not use external analytics, tracking, map, advertising, or profiling providers.
                                    <br/><br/>
                                    5. Legal Basis for Processing
                                    <br/><br/>
                                    Under the GDPR, no legal basis for processing personal data is required in normal
                                    website use because no personal data is processed.
                                    <br/><br/>
                                    If you contact us by email, your submitted data is processed only to handle your
                                    request.
                                    <br/><br/>
                                    6. How We Share Your Data
                                    <br/><br/>
                                    We do not sell, share, transfer, or disclose personal data to third parties because
                                    we do not process personal data through this website.
                                    <br/><br/>
                                    7. Data Retention
                                    <br/><br/>
                                    We do not retain personal data from website usage because such data is not
                                    collected.
                                    <br/><br/>
                                    8. Your Rights Under GDPR
                                    <br/><br/>
                                    As an EU resident, you have the following rights regarding your personal data:
                                    <br/><br/>
                                    Right to Information, Access, Rectification, Erasure, Restriction, and Objection:
                                    These rights apply where personal data processing takes place.
                                    <br/><br/>
                                    Since we do not process personal data in normal website use, these rights are
                                    generally not triggered by using this site.
                                    <br/><br/>
                                    9. Security Measures
                                    <br/><br/>
                                    We implement appropriate technical and organizational measures to keep the website
                                    secure and to prevent unauthorized access.
                                    <br/><br/>
                                    10. Changes to This Privacy Policy
                                    <br/><br/>
                                    We may update this policy from time to time. Changes will be posted on this page
                                    with an updated effective date.
                                    <br/><br/>
                                    11. Contact Information
                                    <br/><br/>
                                    If you have any questions about this Privacy Policy, please contact us at: <a
                                    href={`mailto:info@kooksurfffinder.com`}>info@kooksurfffinder.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id={"bg-image"} className={"layer full-screen"}/>
    </div>
};

export default PrivacyOnePDF;
